<template>
    <div v-if="!loading">
        <div class="loading-spinner-outer" v-if="saving_file_number > 0">
            <div class="loading-spinner-inner">
                <div class="loading-spinner"></div>
                <div class="loading-spinner-content">
                    Uploading file {{ saving_file_number }} of {{ new_message_attachments.length }}, please wait
                </div>
            </div>
        </div>
        <div class="loading-spinner-outer" v-if="sending">
            <div class="loading-spinner-inner">
                <div class="loading-spinner"></div>
                <div class="loading-spinner-content">
                    Sending, please wait
                </div>
            </div>
        </div>
        <div class="box">
            <div class="box-content">
                <div class="flex-2xs justify-between mb-3">
                    <div class="flex flex-col justify-around">
                        <div>
                            <strong>Last Updated:</strong> {{ enquiry.friendly_last_updated }}
                        </div>
                    </div>
                    <div class="flex">
                        <template v-if="staff_user">
                            <div class="flex flex-col justify-around pr-3">
                                <strong>Status</strong>
                            </div>
                            <div>
                                <select v-model="enquiry.enquiry_status_id" class="form-control" @change="updateStatus">
                                    <option v-for="status in enquiry_statuses" :value="status.id">
                                        {{ status.label }}
                                    </option>
                                </select>
                            </div>
                        </template>
                        <template v-else>
                            <div>
                                <strong>Status:</strong> {{ enquiry.enquiry_status.label }}
                            </div>
                        </template>
                        <div class="flex pl-6" v-show="staff_user">
                            <div class="flex flex-col justify-around pr-3">
                                <strong>Assigned&nbsp;To</strong>
                            </div>
                            <select v-model="enquiry.assigned_to" class="form-control" @change="updateAssignedTo">
                                <option :value="null">Nobody</option>
                                <option v-for="staff_user in staff_users" :value="staff_user.id">
                                    {{ staff_user.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="enquiry-messages">
                    <div class="enquiry-message" v-for="message in enquiry.messages">
                        <div class="enquiry-message-header">
                            <div class="from">
                                <template v-if="logged_in_user.id == message.from_user.id">
                                    From: <span class="txt-secondary">You</span>
                                </template>
                                <template v-else>
                                    From:
                                    <template v-if="message.from_user.company_id !== 1">
                                        {{ message.from_user.company.name }} -
                                    </template>
                                    <template v-if="logged_in_user.isStaff && message.from_user.company_id !== 1">
                                      ({{ message.from_user.company.company_type.label }})
                                    </template>
                                    <template v-if="logged_in_user.isStaff">
                                        <a :href="`/manage-customer/${message.from_user.id}`" class="txt-primary" target="_blank">
                                            {{ message.from_user.name }}
                                        </a>
                                    </template>
                                    <template v-else>
                                        {{ message.from_user.name }}
                                    </template>
                                    <template v-if="message.from_user.company_id !== 1">
                                        - {{ message.from_user.email }}
                                    </template>
                                </template>
                            </div>
                            <div class="date">
                                {{ message.friendly_created_at }}
                            </div>
                        </div>
                        <div class="enquiry-message-content" v-html="message.message"></div>
                        <div class="enquiry-message-attachments" v-if="message.attachments.length > 0">
                            <a class="attachment cursor-pointer" v-for="attachment in message.attachments" target="_blank" @click.stop-prevent="downloadAttachment(attachment.id)"
                               :data-filename="attachment.file_name">
                                <div class="icon">
                                    <i class="fal fa-paperclip"></i>
                                </div>
                                <div class="filename">
                                    {{ attachment.file_name }}
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="box mt-3 mt-6-sm">
            <div class="box-content">
                <div class="flex-sm">
                    <div class="full-width half-width-sm pr-3-sm">
                        <div class="form-group">
                            <template v-if="!logged_in_user.isCustomer">
                                <label>Compose new message to customer</label>
                            </template>
                            <template v-else>
                                <label>Compose new message</label>
                            </template>
                            <textarea rows="15" v-model="new_enquiry_message" class="form-control" style="height: 200px;"></textarea>
                        </div>
                    </div>
                    <div class="full-width half-width-sm pl-3-sm">
                        <div class="form-group h-full flex flex-col">
                            <label>Upload Attachments</label>
                            <form :action="`${$aws_upload_url}`" method="post"
                                  enctype="multipart/form-data" id="amazon_form">
                                <input type="hidden" name="policy" :value="aws_policy">
                                <input type="hidden" name="x-amz-algorithm" value="AWS4-HMAC-SHA256">
                                <input type="hidden" name="x-amz-credential" :value="aws_credential">
                                <input type="hidden" name="x-amz-date" :value="aws_date">
                                <input type="hidden" name="x-amz-signature" :value="aws_signature">
                                <input type="hidden" name="acl" value="private">
                            </form>
                            <vue-dropzone
                                    ref="fileUploadDropzone"
                                    id="dropzone"
                                    :options="dropzoneOptions"
                                    v-on:vdropzone-file-added="fileAddedToDropZone"
                                    v-on:vdropzone-removed-file="fileRemovedFromDropZone"
                                    :useCustomSlot="true"
                            >
                                <div>
                                    <div class="mb-3">
                                        DRAG AND DROP FILE
                                    </div>
                                    <div class="mb-3">
                                        OR
                                    </div>
                                    <div>
                                        <a class="btn-secondary-outline">
                                            Choose a file
                                        </a>
                                    </div>
                                </div>
                            </vue-dropzone>
                        </div>
                    </div>
                </div>
                <div class="align-right">
                    <a class="btn-primary" @click.prevent="sendEnquiryMessage()">
                        Send Message
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import vue2Dropzone from 'vue2-dropzone';

  export default {
    mounted() {
      this.loadEnquiry();

      setTimeout(() => {
        this.markMessagesAsRead();
      }, 3000);

    },
    props: [
      'logged_in_user',
      'staff_user',
      'enquiry_id',
      'enquiry_statuses',
      'staff_users',
      'aws_policy',
      'aws_credential',
      'aws_date',
      'aws_signature',
    ],
    data() {
      return {
        enquiry: {
          enquiry_status_id: null,
          assigned_to: null,
        },
        loading: true,
        new_enquiry_message: '',
        sending: false,
        saving_file: false,
        uploaded_file: null,
        new_message_attachments: [],
        new_message_attachment_info: [],
        saving_file_number: 0,
        dropzoneOptions: {
          url: '/',
          autoProcessQueue: false,
          uploadMultiple: true,
          addRemoveLinks: true,
        },
      }
    },
    components: {
      'vue-dropzone': vue2Dropzone,
    },
    methods: {
      fileAddedToDropZone(uploadedFile) {
        const extension = uploadedFile.name.replace(/^.*\./, '');
        const original_file_name = uploadedFile.name.replace('.' + extension, '');

        let new_upload = {};

        new_upload.name = original_file_name;
        const filename = 'enquiry_attachments/' + original_file_name + '_' + Date.now();
        new_upload.filename = filename + '.' + extension;

        if (extension.toLowerCase() === 'svg') {
          new_upload.thumbnail_url = new_upload.filename;
        } else {
          new_upload.thumbnail_url = 'thumbnails/' + filename + '.png';
        }

        new_upload.filetype = uploadedFile.type;
        new_upload.uploaded_file = uploadedFile;
        new_upload.original_file_name = original_file_name;
        new_upload.file_url = filename;

        this.new_message_attachments.push(new_upload);
        this.new_message_attachment_info.push({
          original_file_name: original_file_name,
          filename: filename + '.' + extension,
        });
      },
      fileRemovedFromDropZone(file) {
        const extension = file.name.replace(/^.*\./, '');
        const original_file_name = file.name.replace('.' + extension, '');
        this.new_message_attachments = this.new_message_attachments.filter(attachment => attachment.original_file_name !== original_file_name);
        this.new_message_attachment_info = this.new_message_attachment_info.filter(attachment => attachment.original_file_name !== original_file_name);
      },
      loadEnquiry() {
        axios.post('/enquiry/loadEnquiry', {
          enquiry_id: this.enquiry_id,
        }).then((response) => {
          this.enquiry = response.data;
          this.loading = false;
        }).catch((error) => {
          if (error.response.status === 403) {
            window.location.href = '/login';
          }
        });
      },
      async sendEnquiryMessage() {

        if (this.new_enquiry_message === '') {
          Swal.fire({
            title: 'Please enter a message',
            icon: 'error',
          });
          return;
        }

        if (this.new_message_attachments.length < 1) {
          this.sendMessage();
          return;
        }

        this.saving_file_number = 1;

        await this.new_message_attachments.forEach(async (upload, index) => {
          let form_data = new FormData(document.querySelector('#amazon_form'));
          form_data.append('Content-Type', upload.filetype);
          form_data.append('key', upload.filename);
          form_data.append('file', upload.uploaded_file);

          await axios({
            method: 'post',
            url: this.$aws_upload_url,
            data: form_data,
            headers: {'Content-Type': 'multipart/form-data'}
          }).then(async () => {

            if(this.saving_file_number === this.new_message_attachments.length) {
              this.sendMessage();
            } else {
              this.saving_file_number = this.saving_file_number + 1;
            }

          });
        });

      },
      updateStatus(event) {
        if (!this.loading) {
          axios.post('/enquiry/updateStatus', {
            enquiry_id: this.enquiry_id,
            enquiry_status_id: Number(event.target.value),
          }).then((response) => {
            Swal.fire({
              title: 'Status Updated',
              icon: 'success',
            });
          });
        }
      },
      updateAssignedTo(event) {
        if (!this.loading) {
          axios.post('/enquiry/updateAssignedTo', {
            enquiry_id: this.enquiry_id,
            assigned_to: Number(event.target.value),
          }).then((response) => {
            Swal.fire({
              title: 'Enquiry Assigned',
              icon: 'success',
            });
          });
        }
      },
      sendMessage() {
        this.sending = true;
        axios.post('/enquiry/sendEnquiryMessage', {
          from_user_id: this.logged_in_user.id,
          enquiry_id: this.enquiry_id,
          enquiry_message: this.new_enquiry_message,
          attachments: this.new_message_attachment_info,
        }).then((response) => {
          this.loadEnquiry();
          this.new_enquiry_message = '';
          this.sending = false;
          this.saving_file_number = 0;
          this.$refs.fileUploadDropzone.dropzone.removeAllFiles();
          this.new_message_attachments = [];
          this.new_message_attachment_info = [];
        });
      },
      downloadAttachment(attachment_id) {
        axios.post('/enquiry/download-attachment', {
          attachment_id: attachment_id,
        }).then((response) => {
          window.location.href = response.data;
        });
      },
      markMessagesAsRead() {
        axios.post('/enquiry/mark-messages-as-read', {
          enquiry_id: this.enquiry_id,
        });
      },
    },
  };
</script>
